/**
 * Created by Dean on 2017/12/06.
 * http配置
 */
import axios from 'axios';
// import api from '../api/api';
// import loginApi from '../../config/api'
import Vue from 'vue';
import { Message } from 'iviewxx';
Vue.component('Message', Message);
// axios 配置
axios.defaults.timeout = 50000;
axios.defaults.baseURL = '';
axios.defaults.responseType = 'json';
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Accept'] = 'application/json;';
axios.defaults.headers.post['Content-Type'] = 'application/json;';
axios.defaults.headers.delete['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.delete['Accept'] = 'application/json;';
axios.defaults.headers.delete['Content-Type'] = 'application/json;';
axios.defaults.headers.put['Content-Type'] = 'application/json;';
axios.defaults.headers.put['Accept'] = 'application/json;';
axios.defaults.headers.get['Content-Type'] = 'application/json;';
axios.defaults.headers.get['Accept'] = 'application/json;';
// axios.defaults.headers.delete['Content-Type'] = 'application/json;';
// http request 拦截器
axios.interceptors.request.use(function(config) {
        var token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = token;
        } else {
            console.log('终于登进来了！');
            sessionStorage.removeItem('token');
            // debugger;
        }
        return config;
    },
    function(err) {
        return Promise.reject(err);
    });
// http response 拦截器
axios.interceptors.response.use(function(response) {
    var url = window.location.href;
    // console.log(url);
    if (response.data.code === 999998) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('ticket');
        if (url.indexOf('ticket') > 0) url = url.split('?ticket')[0];
        // localStorage.setItem('logUrl',response.data.others.loginUrl  + encodeURIComponent(url));
        window.location.href = response.data.others.loginUrl + encodeURIComponent(url);
    } else if (response.data.code === 403) {
        Message.error('No Permission');
        return response;
    } else if (response.data.code === 999999) {
        Message.error('System Error');
        return Promise.reject('接口报错了，请在控制台查看接口错误');
    } else {
        return response;
    }
    return response;
}, function(error) {
    if (error.response) {
        return Promise.reject(error.response.data);
    } else {
        return Promise.reject(error);
    }
});


// WEBPACK FOOTER //
// ./src/assets/http.js